// extracted by mini-css-extract-plugin
export var content = "_co-3";
export var list = "_co-4";
export var settingsContent = "_co-7";
export var settingsPanel = "_co-8";
export var state = "_co-6";
export var triggerBadge = "_co-2";
export var triggerButton = "_co-1";
export var triggerShell = "_co-0";
export var unreadDot = "_co-5";